import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { PostHogProvider } from "posthog-js/react";
import { posthog, initPostHog } from "./lib/posthog";
import { App } from "./App";
import { initTheme } from "./hooks/useTheme";
import "./styles/globals.css";

// Initialize PostHog before React renders (avoids StrictMode double-init)
initPostHog();

// Resolve + apply the theme (light/dark) and start following the OS preference
// while no explicit choice is stored. The inline head script in index.html has
// already set the class to prevent FOUC; this keeps React authoritative.
initTheme();

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </StrictMode>
);
